import { render } from "./SubSecondRecommendedSettings.vue?vue&type=template&id=1d8ce296"
import script from "./SubSecondRecommendedSettings.vue?vue&type=script&lang=js"
export * from "./SubSecondRecommendedSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SubSecondStream/SubSecondRecommendedSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d8ce296"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d8ce296', __exports__)) {
    api.reload('1d8ce296', __exports__)
  }
  
  module.hot.accept("./SubSecondRecommendedSettings.vue?vue&type=template&id=1d8ce296", () => {
    api.rerender('1d8ce296', render)
  })

}


export default __exports__